export default {"src":"/_next/static/media/beetgreens.efa7a954.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};